import React, { Component } from 'react';

class FormErrors extends Component {

    render() {

        const formErrors = this.props.formErrors;

        // TODO refactor this to a tidy loop
        if (
            formErrors.first_name.length > 0 ||
            formErrors.last_name.length > 0 ||
            formErrors.company_name.length > 0 ||
            formErrors.phone.length > 0 ||
            formErrors.email.length > 0 ||
            formErrors.message.length > 0
        ) {

        return (

            <div className='formErrors' role="alert">
                <h4>Please fix the following issues:</h4>
                <ul>
                    {
                        Object.keys(formErrors).map((fieldName, i) => {
                            if(formErrors[fieldName].length > 0){
                                return (
                                    <li key={i}>{formErrors[fieldName]}</li>
                                )        
                            } else {
                                return '';
                            }
                        })
                    }
                </ul>
            </div>
        )
        } else {
            return ( <div className="noErrors"></div>)
        }
    }
}

export default FormErrors;


// WEBPACK FOOTER //
// ./src/components/FormErrors/FormErrors.js